import { api, setConfig } from '../..';
import { mapEntityToApi } from './mapper';
import { PropertyType } from '../../../common';

export const getUserReportsByUser = (data: PropertyType): Promise<PropertyType[]> =>
	api.post('/user/mail-reports', mapEntityToApi(data), setConfig(data)).then((res) => {
		return res.data;
	});
